<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UcExpiringContractNotificationCard',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    notification: {
      type: Object,
      required: true,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const ux = ref([]);

  const $data = computed(() => ({
    ux: ux.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'ux' }],
    loaders: {},
    ux: {},
    dataRefs: { ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.notification,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('notification');
    }
  );

  const act_7315092382398562_reloadComponentData_cv829o2s1 =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_gvch2i79x =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_cv829o2s1,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_gvch2i79x],
    event: 'reload',
  });

  const actions = {
    inst_evh_7315092382398562_reload_gvch2i79x,
    inst_evh_7315092382398562_reload,
  };

  const evh_7315092382398562_reload_gvch2i79x = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_gvch2i79x.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <ItpBox direction="row" alignItems="start">
      <div class="me-3 pt-1">
        <Icon icon="pajamas:expire" :tooltip="gettext('Expiring contract')">
        </Icon>
      </div>
      <ItpBox direction="column">
        <ItpText :text="gettext('Expiring contract')" strong tag="h5">
        </ItpText>
        <ItpBox direction="row" class="mb-2">
          <UcContractMiniCard :item="notification.data.contract_data" no-icon>
          </UcContractMiniCard>
          <span class="mx-3"> &middot; </span>
          <UcCompanyMiniCard
            :item="notification.data.contract_data.counterparty"
            no-icon
          >
          </UcCompanyMiniCard>
          <span class="mx-3"> &middot; </span>
          <ItpText class="me-2">
            {{ gettext('End date') }}
          </ItpText>
          <strong>
            {{ date(notification.data.valid_to) }}
          </strong>
        </ItpBox>
        <ItpText small muted>
          {{ datetime(notification.created_at) }}
          {{ username(notification.created_by) }}
        </ItpText>
      </ItpBox>
    </ItpBox>
  </ItpUsercontrol>
</template>
